// src/pages/Products/Products.js
import React, { useEffect, useState } from 'react';
import { fetchProducts } from '../../services/productService/productService';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import './Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts()
      .then((data) => setProducts(data.content || data))
      .catch((error) => console.error('Failed to load products', error));
  }, []);

  return (
    <motion.section
      id="products"
      className="products-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <Helmet>
        <title>Our Products | UBR Engineering Works</title>
        <meta
          name="description"
          content="Discover the range of high-quality industrial machines manufactured by UBR Engineering Works. Designed for performance, durability, and reliability."
        />
        <meta
          name="keywords"
          content="engineering products, industrial machinery, UBR Engineering, heavy machines, machine tools, manufacturing equipment"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <h5 className="products-subtitle">--- WHAT WE OFFER ---</h5>
      <h2 className="products-title">Our Products</h2>
      <div className="products-underline"></div>

      <div className="products-grid">
        {products.length > 0 ? (
          products.slice(0, 4).map((product, index) => (
            <motion.div
              key={index}
              className="products-card"
              whileHover={{
                scale: 1.05,
                boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
              }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={product.image}
                alt={product.name || 'Product Image'}
                className="products-image"
                loading="lazy"
                decoding="async"
              />
              <h3 className="products-card-title">{product.name}</h3>
              <p className="products-card-text">{product.description}</p>
              <p className="products-specs"><strong>Specs:</strong> {product.specs}</p>
            </motion.div>
          ))
        ) : (
          <p className="products-no">No products available.</p>
        )}
      </div>

      <button className="products-button" onClick={() => navigate('/all-products')}>
        See More
      </button>
    </motion.section>
  );
};

export default Products;
